var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"public-app",attrs:{"id":"app"}},[_c('v-main',{staticStyle:{"overflow":"hidden"}},[_c('router-view'),_c('fin-cookie-declaration')],1),_c('fin-alert'),_c('fin-lexicon-overlay')],1)}
var staticRenderFns = []

export { render, staticRenderFns }